import { render, staticRenderFns } from "./QualityInspectionRules.vue?vue&type=template&id=4efa0df3&scoped=true&"
import script from "./QualityInspectionRules.vue?vue&type=script&lang=ts&"
export * from "./QualityInspectionRules.vue?vue&type=script&lang=ts&"
import style0 from "./QualityInspectionRules.vue?vue&type=style&index=0&id=4efa0df3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efa0df3",
  null
  
)

export default component.exports